import { createStore } from "vuex";
import auth from "./auth";
import levelSessions from "./levelSessions";
import dashboardStats from "./dashboardStats";
import groupDashboardStats from "./groupDashboardStats";

export default createStore({
  modules: {
    auth,
    levelSessions,
    dashboardStats,
    groupDashboardStats
  },
});